import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import CSSTransitionReplace from 'react-css-transition-replace';

const propTypes = {
  withHeightAnimation: PropTypes.bool,
  withCrossFade: PropTypes.bool,
  crossFadeWrapperClass: PropTypes.string,
};

const defaultProps = {
  withHeightAnimation: false,
  withCrossFade: false,
  crossFadeWrapperClass: undefined,
};

const FadeTransition = ({
  children,
  withHeightAnimation,
  withCrossFade,
  crossFadeWrapperClass,
}) => {
  if (withHeightAnimation) {
    return (
      <CSSTransitionReplace
        transitionName="CSSTG-fade"
        transitionEnterTimeout={375}
        transitionLeaveTimeout={300}
      >
        {children}
      </CSSTransitionReplace>
    );
  }

  if (withCrossFade) {
    const crossFadeProps = { className: crossFadeWrapperClass };

    return (
      <CSSTransitionGroup
        {...crossFadeProps}
        component="div"
        transitionName="CSSTG-cross-fade"
        transitionEnterTimeout={3750}
        transitionLeaveTimeout={3000}
      >
        {children}
      </CSSTransitionGroup>
    );
  }

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="CSSTG-fade"
      transitionEnterTimeout={375}
      transitionLeaveTimeout={300}
    >
      {children}
    </CSSTransitionGroup>
  );
};

FadeTransition.propTypes = propTypes;
FadeTransition.defaultProps = defaultProps;

export default FadeTransition;



// WEBPACK FOOTER //
// ../ui-components/components/FadeTransition/index.jsx